import { createTheme, Theme } from '@mui/material/styles';

// Creating a theme instance.
const lightTheme: Theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      paper: '#fff'
    },
    grey: {
      '100': '#f8fafb'
    },
    primary: {
      main: '#2241A6',
      dark: '#1E3565'
    },
    text: {
      primary: '#262626'
    },
    action: {
      active: '#001E3C'
    }
  },
  typography: {
    fontFamily: ['sourceSansProFont', 'sans-serif']?.join(',')
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-filledInfo': {
            backgroundColor: '#EBF8FF', // Customize background color for info variant
            color: '#5599CD' // Optional: Customize text color
          }
        },
        deleteIcon: {
          '&.MuiChip-deleteIconColorInfo': {
            color: '#5599CD' // Custom icon color for info variant
          }
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1300, // CUSTOM BREAKPOINT
      lg: 1600,
      xl: 1920
    }
  }
});

export default lightTheme;
